import { Link } from 'react-router-dom';
import { works } from '@/mocks/works';

export default function WorksSection() {
  return (
    <section className="bg-background-100/70 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-18">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
              <i className="ri-film-line" />
              收录作品
            </span>
            <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">作品专题</h2>
          </div>
          <Link to="/works" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-600 whitespace-nowrap">
            全部作品
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {works.slice(0, 6).map((work) => (
            <Link
              key={work.id}
              to="/works"
              className="group overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={work.image}
                  alt={`${work.name} - ${work.subtitle}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/55 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
                  {work.year} · {work.genre}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-primary-900">
                  <i className="ri-star-fill text-[11px]" />
                  {work.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">{work.name}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{work.subtitle}</p>
                <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{work.description}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {work.tags.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{t}</span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}